import React from 'react';
import { AccordionItem } from '../ui/Accordion';
export function FAQSection() {
  const faqs = [{
    question: '¿Cómo accedo al material después de comprar?',
    answer: 'Inmediatamente después de tu pago recibís un email con el enlace de descarga. El PDF llega a tu correo en minutos y lo podés guardar en tu teléfono, tablet o computadora. No hay que esperar ni instalar nada.'
  }, {
    question: '¿Sirve si soy principiante y nunca hice cosmética en casa?',
    answer: 'Sí, especialmente para vos. El sistema está diseñado para que alguien que nunca terminó una receta bien pueda empezar con bases sólidas. No se asume ningún conocimiento técnico previo. Si ya tenés experiencia, vas a encontrar en la sección de troubleshooting y en los criterios de seguridad todo lo que siempre te faltó.'
  }, {
    question: '¿Es un pago único o hay suscripción?',
    answer: 'Pago único. Pagás una vez y el material es tuyo para siempre. No hay cargos mensuales, no hay renovación automática, no hay letra chica. Acceso permanente.'
  }, {
    question: '¿Qué pasa si lo compro y no me sirve?',
    answer: 'Tenés 7 días de garantía completa. Si abrís el material y no encontrás valor real, me escribís un email y te devuelvo el 100% del pago. Sin preguntas. Sin formularios.'
  }, {
    question: '¿Esto no es lo mismo que lo que encuentro gratis en internet?',
    answer: 'Es exactamente la pregunta correcta. La diferencia no está en los ingredientes — está en la estructura. Las recetas gratuitas te dan una lista. Este sistema te da proporciones exactas, criterios de seguridad, tiempo de vida útil, opciones de sustitución por país y troubleshooting para cuando algo falla. Eso no existe gratis. Si existiera, no lo estarías buscando.'
  }];
  return <section className="py-10 md:py-16 px-4 bg-cream" data-id="element-21">
      <div className="max-w-[700px] mx-auto" data-id="element-22">
        <h2 className="text-[26px] md:text-[32px] text-primary-dark text-center mb-8" data-id="element-23">
          Preguntas frecuentes
        </h2>

        <div className="border-t border-divider" data-id="element-24">
          <div className="py-2" data-id="element-25">
            <span className="text-[12px] font-bold text-pain uppercase tracking-wider" data-id="element-26">
              La pregunta más importante:
            </span>
          </div>
          {faqs.map((faq, index) => <AccordionItem key={index} question={faq.question} answer={faq.answer} data-id="element-27" />)}
        </div>

        <p className="text-[15px] text-center text-ink font-bold mt-8" data-id="element-28">
          ¿Todavía tenés dudas?{' '}
          <a href="mailto:hola@antesdequeseatarde.com" className="text-pain hover:underline" data-id="element-29">
            hola@antesdequeseatarde.com
          </a>
        </p>
      </div>
    </section>;
}